import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "Formação:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Valor por hora:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Mod. Repasse:", -1)

import { computed } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'CardDutyFee',
  props: {
    formation: {},
    value: {},
    repassMode: {},
    active: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props;





const formattedValue = computed(() =>
  props.value !== undefined ? `R$ ${props.value.toFixed(2).replace('.', ',')}` : null
)

const formattedRepassMode = computed(() => {
  const dictRepassMode: Record<string, string> = {
    FLOW: 'Fluxo',
    IMMEDIATE: 'À vista'
  }

  return dictRepassMode[props.repassMode] || 'Fluxo'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    class: _normalizeClass(["p-3 border rounded-lg shadow-sm bg-white text-sm w-fit leading-relaxed text-left cursor-pointer transition-all duration-200 ease-in-out hover:shadow-md min-w-[250px]", _ctx.active ? 'border-primary' : 'border-gray-200 hover:border-primary-300'])
  }, [
    (!!_ctx.formation)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.formation), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", null, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(formattedValue.value), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(formattedRepassMode.value), 1)
    ])
  ], 2))
}
}

})